module.exports = __webpack_public_path__ + "img/Diaconovici-Loga_Gramatica_romaneasca_pentru_indreptarea_tinerilor_Buda_1822.1137481c.jpg";